module.exports = __webpack_public_path__ + "static/img/fixed.7a4f52f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cashflow-tour/fixed.png
// module id = suYz
// module chunks = 6